export default __webpack_public_path__ + "static/media/layout05.765b8fe2.png";